import {useEffect} from "react";
import {useSelector} from "react-redux";
import {GAME_STATE} from "utils";
import {upsertIpxWorldHistory} from "api-v3";
import View from "./View";

export default function Container() {
  const {gameState} = useSelector(state => state.game);

  useEffect(() => {
    const enterDonutDrive = async () => {
      try {
        await upsertIpxWorldHistory({
          worldType: "DONUTDRIVE",
          isInit: true,
        });
      } catch (error) {
        console.log(error);
      }
    };

    enterDonutDrive();
  }, []);

  useEffect(() => {
    if (gameState === GAME_STATE.PLAYING) {
    } else if (gameState === GAME_STATE.ENDED) {
      const endDonutDrive = async () => {
        try {
          await upsertIpxWorldHistory({
            worldType: "DONUTDRIVE",
          });
        } catch (error) {
          console.log(error);
        }
      };

      endDonutDrive();
    }
  }, [gameState]);
  return <View gameState={gameState} />;
}
